import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  putAPI_Delete_QuestionSet,
  gAPI_Question_MessagesList,
  API_OpenAI_Assistant,
} from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import short from 'short-uuid';
import ReactDragListView from 'react-drag-listview';
import { List, Typography } from 'antd';
import 'antd/dist/reset.css';
import Question from './Question';
import { Row, Collapse, Button, Card, CardBody } from 'reactstrap';
import { faEdit, faTrashAlt, faCopy } from '@fortawesome/free-solid-svg-icons';
import QuestionSetForm from './QuestionSetForm';
import CopyToClipboard from 'react-copy-to-clipboard';
function QuestionSet({
  set,
  index,
  loadResponse,
  locale,
  setQCollasp,
  collapseSet,
  quesionSetsList,
  roomTags,
  productList,
  productTags,
  formList,
  onDragEnd,
}) {
  const [isAddQuestion, setIsAddQuestion] = useState(false);
  const [seriesName, setSeriesName] = useState(set.name);
  const [seriesDescription, setSeriesDescription] = useState(set.description);
  const [isEditing, setIsEditing] = useState(false);
  const [messagesList, setMessagesList] = useState([]);
  const [collapseQuestion, setCollapseQuestion] = useState(-1);

  useEffect(() => {
    if (set !== undefined) {
      AxiosAPI({
        methed: 'get',
        url: `${gAPI_Question_MessagesList}/?setId=${set.id}&lang=${locale === 'en' ? 'en-US' : locale
          }`,
      })
        .then((res) => {
          setMessagesList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [set]);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const setCollaspQuestion = (e) => {
    if (collapseQuestion === e) {
      setCollapseQuestion(-1);
    } else {
      setCollapseQuestion(e);
    }
  };

  const updateSet = (name, des) => {
    setSeriesName(name);
    setSeriesDescription(des);
    toggleEdit();
  };

  const deleteSet = () => {
    let data = {
      Deleter: 'Dashboard',
    };
    try {
      if (
        set.openAiAssistantId !== undefined &&
        set.openAiAssistantId !== null &&
        set.openAiAssistantId !== ''
      ) {
        AxiosAPI({
          method: 'delete',
          url: `${API_OpenAI_Assistant}/delete/${set.openAiAssistantId}?id=${set.id}`,
        }).then((res) => { });
      }
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Delete_QuestionSet}/${set.id}`,
        data: data,
      }).then(() => {
        loadResponse();
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Fragment>
      <Colxx
        xxs="12"
        xs="12"
        className="question-set-background mt-3"
        index={index}
      >
        <div>
          <div
            className="collapse-btn"
            onClick={() => setQCollasp(index)}
            aria-expanded={collapseSet === index}
          >
            <h3>{seriesName}</h3>
          </div>
          <Collapse isOpen={collapseSet === index}>
            {set.type === 'ConversationFlow' ||
              set.type === 'DynamicConversationFlow' ? (
              <Fragment>
                <span className="collapse-span text-muted">
                  {seriesDescription}
                </span>
              </Fragment>
            ) : (
              ''
            )}
            {set.type === 'DynamicConversationFlow' &&
              set.openAiAssistantId !== undefined &&
              set.openAiAssistantId !== null &&
              set.openAiAssistantId !== '' ? (
              <Fragment>
                <span className="collapse-span text-muted">
                  {set.openAiAssistantId}
                </span>
              </Fragment>
            ) : (
              <Fragment>
                <span className="collapse-span text-muted">
                  {set.id}
                  <CopyToClipboard className="ml-1" text={set.id}>
                    <Button
                      outline
                      size="xs"
                      color="primary"
                      style={{
                        float: 'right',
                        color: 'grey',
                        border: 'none',
                      }}
                      className="my-2"
                    >
                      <FontAwesomeIcon icon={faCopy}></FontAwesomeIcon>
                    </Button>
                  </CopyToClipboard>
                </span>
              </Fragment>
            )}
            <FontAwesomeIcon
              icon={faEdit}
              color="#90caf9"
              cursor="pointer"
              onClick={toggleEdit}
            />
            <b> | </b>
            <FontAwesomeIcon
              icon={faTrashAlt}
              style={{ color: 'var(--theme-color-1)' }}
              cursor="pointer"
              onClick={() => deleteSet()}
            />
            <Collapse isOpen={isEditing}>
              <Colxx
                xxs="12"
                className="mb-2 p-4"
                style={{ border: 'solid 1px #4556ac' }}
              >
                <QuestionSetForm
                  loadResponse={loadResponse}
                  actions={set.actions}
                  CancelQuestionSet={toggleEdit}
                  setName={set.name}
                  seriesTrainingData={set.flowTrainingData}
                  seriesFlowInvokeApi={set.flowInvokeApi}
                  setInstructions={set.instructions}
                  setDescription={set.description}
                  seriesConversationFlow={set.publishConversationFlow}
                  aiModel={set.openAiModel}
                  aiAssistantId={set.openAiAssistantId}
                  updateSet={updateSet}
                  setId={set.id}
                  type={set.type}
                  setIsGroupVisible={set.isGroupVisible}
                  aiReasoningEfforts={set.openAiReasoningEfforts}
                  aiVerbosity={set.openAiVerbosity}
                ></QuestionSetForm>
              </Colxx>
            </Collapse>
            {set.type !== 'DynamicConversationFlow' &&
              set.questions === null && (
                <div className="mb-5 text-center question-set-border">
                  <Row>
                    <Colxx xxs="12" className="mb-4">
                      <div className="content text-center">
                        <img
                          src={
                            'https://bmbuiassetsprod.blob.core.windows.net/images/question.png'
                          }
                          alt="example"
                          width="auto"
                          className="img-thumbnail"
                        />
                      </div>
                    </Colxx>
                  </Row>
                  <Row>
                    <Colxx xxs="12" className="mb-4">
                      <h2>First Question you will ask to start filtering</h2>
                      <p>
                        First question you will ask to help people filter the
                        most relevant products & promotions for them
                      </p>
                    </Colxx>
                  </Row>
                  <Row>
                    <Colxx xxs="12" className="mb-4">
                      <Fragment>
                        <div
                          onClick={() => {
                            setIsAddQuestion(true);
                          }}
                          className="mb-3"
                        >
                          <Button
                            color="primary"
                            className="add-button"
                            size="xs"
                            style={{ width: '100%' }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            <span> </span>
                            Ask a Question
                          </Button>{' '}
                        </div>
                        {isAddQuestion && (
                          <Question
                            code={short.uuid()}
                            isDynamicFlow={
                              set.type === 'DynamicConversationFlow'
                                ? true
                                : false
                            }
                            index={index}
                            loadResponse={loadResponse}
                            setId={set.id}
                            setType={set.type}
                            setCollaspQuestion={setCollaspQuestion}
                            collapseQuestion={index}
                          />
                        )}{' '}
                      </Fragment>
                    </Colxx>
                  </Row>
                </div>
              )}
            {set.questions !== null && (
              <ReactDragListView
                nodeSelector=".ant-list-item.draggable-item"
                lineClassName="dragLine"
                onDragEnd={(fromIndex, toIndex) =>
                  onDragEnd(fromIndex, toIndex, 'QUESTION-LIST-ITEM', index)
                }
              >
                {set.questions.map((question, qindex) => {
                  return (
                    <List.Item key={qindex} className="draggable-item">
                      <div
                        className="d-flex flex-row"
                        style={{ width: '100%' }}
                      >
                        <span className="mr-1 draggable-item-span">
                          <a href="#">
                            <i className="simple-icon-menu svg-class"></i>
                          </a>
                        </span>
                        <Question
                          code={question.code}
                          index={qindex}
                          loadResponse={loadResponse}
                          QuestionId={question.id}
                          isDynamicFlow={
                            set.type === 'DynamicConversationFlow'
                              ? true
                              : false
                          }
                          Question={question}
                          setType={set.type}
                          messagesList={messagesList}
                          setCollaspQuestion={setCollaspQuestion}
                          collapseQuestion={collapseQuestion}
                          quesionSetsList={quesionSetsList}
                          roomTags={roomTags}
                          productList={productList}
                          productTags={productTags}
                          formList={formList}
                        />
                      </div>
                    </List.Item>
                  );
                })}
              </ReactDragListView>
            )}
            {set.type !== 'DynamicConversationFlow' &&
              set.questions !== null &&
              set.questions.length > 0 && (
                <Fragment>
                  <div
                    onClick={() => {
                      setIsAddQuestion(true);
                    }}
                    className="mb-3 mt-2"
                  >
                    <Button
                      color="primary"
                      className="add-button"
                      size="xs"
                      style={{ width: '100%' }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                      <span> </span>
                      Ask a Question
                    </Button>
                  </div>
                  {isAddQuestion && (
                    <Question
                      code={short.uuid()}
                      isDynamicFlow={
                        set.type === 'DynamicConversationFlow' ? true : false
                      }
                      index={index}
                      loadResponse={loadResponse}
                      setId={set.id}
                      setType={set.type}
                      setCollaspQuestion={setCollaspQuestion}
                      collapseQuestion={index}
                    />
                  )}
                </Fragment>
              )}
          </Collapse>
        </div>
      </Colxx>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(QuestionSet));
